import Grid from 'components/core/Grid';
import React, { useCallback, useMemo } from 'react';
import logo from 'assets/images/yubi-logo.png';
import YbCoreNavBar from '@yubi/yb-core-nav-bar';
import { useStyles } from '@yubi/yb-style-provider';
import UserAvatar from './UserAvatar';
import OmsIcon from 'assets/images/list-oms.svg';
import YbCoreTypography from '@yubi/yb-core-typography';
import AppLogo from 'components/AppLogo';

const COMMON_STYLES = {
    fontFamily: 'Sofia Pro',
};
const MENU_ITEMS = [
    {
        label: 'Home',
        key: 'home',
        labelStyle: COMMON_STYLES,
        url: `${process.env.REACT_APP_CREDIT_WEB_HOST}`,
    },
];

const OMS = () => {
    return (
        <a
            href={`${process.env.REACT_APP_CREDIT_WEB_HOST}/order-management`}
            style={{ textDecoration: 'none' }}
        >
            <Grid
                item
                container
                alignItems="center"
                style={{
                    marginRight: 16,
                    background: 'rgb(253, 242, 248)',
                    padding: '6px 10px',
                    borderRadius: 8,
                }}
            >
                <img src={OmsIcon} />
                <YbCoreTypography color="rgb(129, 25, 66)" margin={{ left: 4 }}>
                    Orders
                </YbCoreTypography>
            </Grid>
        </a>
    );
};

const Logo = () => {
    return (
        <div>
            <AppLogo />
        </div>
    );
    /* return (
    <div style={{ width: 160 }}>
      <img src={logo} style={{ width: 91, height: 32 }} />
    </div>
  ); */
};

const Header = () => {
    const { styleConnector } = useStyles();
    const onMenuItemClick = useCallback((menuItem) => {
        window.location.href = menuItem.url;
    }, []);
    const menuItems = useMemo(() => {
        return MENU_ITEMS.map((item) => ({
            ...item,
            onClick: (() => {
                return () => onMenuItemClick(item);
            })(),
        }));
    }, [onMenuItemClick]);

    const HeaderRightElements = useMemo(() => {
        return [<OMS />, <UserAvatar />];
    }, []);

    return (
        <Grid
            item
            container
            style={{
                height: 'auto',
                borderBottom: '1px solid #e7eaee',
                width: '100%',
            }}
        >
            <YbCoreNavBar
                componentType="Web"
                items={menuItems}
                showSearch={false}
                showUser={false}
                containerStyle={{ width: '100%', zIndex: 10 }}
                logoIcon={<Logo />}
                styleConnector={styleConnector}
                rightItems={HeaderRightElements}
            />
        </Grid>
    );
};

export default Header;
